export default __webpack_public_path__ + "static/media/Telegram.2c6478d9.png";